export const bloodTestCreateTranslations = {
    en: {
        fetchOpdFailed: "Failed to fetch OPD numbers!",
        submitSuccess: "Blood test procedure added successfully!",
        submitFailed: "Failed to add procedure!",
        submitting: "Submitting...",
        submit: "Submit",

        patientInformation: "Patient Information",
        tokenNo: "Token No",
        tokenPlaceholder: "Search Token No eg. 00005",
        beneficiaryName: "Beneficiary Name",
        date: "Date",

        tests: "Tests",
        selectTests: "Select Tests",

        remarks: "Remarks",
        remarksPlaceholder: "Enter remarks here",
        uploadFiles: "Upload Files"
    },
    mr: {
        fetchOpdFailed: "ओपीडी क्रमांक आणण्यात अयशस्वी!",
        submitSuccess: "रक्त तपासणी प्रक्रिया यशस्वीरित्या जोडली!",
        submitFailed: "प्रक्रिया जोडण्यात अयशस्वी!",
        submitting: "सबमिट करत आहे...",
        submit: "सबमिट करा",

        patientInformation: "रुग्ण माहिती",
        tokenNo: "टोकन क्रमांक",
        tokenPlaceholder: "टोकन क्रमांक शोधा उदा. 00005",
        beneficiaryName: "लाभार्थीचे नाव",
        date: "तारीख",

        tests: "चाचण्या",
        selectTests: "चाचण्या निवडा",

        remarks: "शेरा",
        remarksPlaceholder: "येथे शेरा प्रविष्ट करा",
        uploadFiles: "फाइल अपलोड करा"
    }
};
